export enum EntityDataGroupingKeys {
    Attributes = 'attributes',
}

export const EntityDataGroupingOptions = [
    { value: EntityDataGroupingKeys.Attributes, label: 'Attribute' },
];
